
export interface Pricing {
  price: string
  currency: 'USD'
  anchor: string
  loading: boolean
}

const PRICING: Pricing = {
  price: '27',
  currency: 'USD',
  anchor: '49',
  loading: false,
}

export function usePricing(): Pricing {
  return PRICING
}
